import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LineItemState_KeepWorking_getInstanceieb6rws75lm1 as LineItemState_KeepWorking_getInstance } from '../../../../crowpay-shared/com/crowpay/enums.mjs';
import { CompletionFlowPermissionsj7m9votfuuvc as CompletionFlowPermissions } from '../../../../crowpay-shared/com/crowpay/completionResponse/CompletionFlowPermissions.mjs';
import {
  ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance,
  ActionImportance_Critical_getInstance3s0xptbpomhhd as ActionImportance_Critical_getInstance,
} from '../views/screens/common/ProjectView.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function requiresAction(_this__u8e3s4, concernsOnly) {
  concernsOnly = concernsOnly === VOID ? false : concernsOnly;
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof CompletionFlowPermissions()) {
    tmp_0 = _this__u8e3s4.i8x_1.p6k_1.equals(LineItemState_KeepWorking_getInstance());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = null;
  } else {
    if (!_this__u8e3s4.a8y() || _this__u8e3s4.s8x().i1() || _this__u8e3s4.v8y()) {
      tmp = null;
    } else {
      if (_this__u8e3s4.t8w()) {
        tmp = ActionImportance_Critical_getInstance();
      } else {
        if (_this__u8e3s4.s8w() || _this__u8e3s4.r8w()) {
          tmp = ActionImportance_Important_getInstance();
        } else {
          if (concernsOnly) {
            tmp = null;
          } else {
            tmp = ActionImportance_Important_getInstance();
          }
        }
      }
    }
  }
  return tmp;
}
//region block: exports
export {
  requiresAction as requiresAction13nb01xm2r5gu,
};
//endregion

//# sourceMappingURL=FlowPermissions.ext.mjs.map
